'use client';

import { renderSelectedLabel } from '@/utils/filters/filterLabel';
import { FC, Fragment, useContext } from 'react';
import Chip from '@/components/Chip';
import AlgonomyContext, { AlgonomyContextState } from '@/context/SearchResultsContext';
import { SelectedFiltersProps } from './types';
import clsx from 'clsx';

import styles from './SelectedFilters.module.css';

const SelectedFilters: FC<SelectedFiltersProps> = ({ className, filterGroups }) => {
  const { handleSelectFilter } = useContext(AlgonomyContext) as AlgonomyContextState;

  return (
    <div className={clsx(styles.selectedFilters, className)}>
      {filterGroups?.map(({ facet, values }) =>
        values.map((value) => (
          <Fragment key={value.value}>
            <Chip
              label={`${renderSelectedLabel(facet, value.value)}`}
              onDelete={() => {
                handleSelectFilter(facet, value.value, value.filter, false);
              }}
            />
          </Fragment>
        )),
      )}
    </div>
  );
};

export default SelectedFilters;
